<template>
  <button
    @click="toggleAvatar"
    :class="[custom]"
    class="group h-11 group rounded-full flex items-center relative cursor-pointer"
    :aria-label="user + ' (opciones de usuario)'"
    @keydown.esc="tooltipVisible = false"
    @mouseenter="tooltipVisible = true"
    @mouseleave="tooltipVisible = false"
    @focus="tooltipVisible = true"
    @blur="tooltipVisible = false"
  >
    <div class="open-user-menu w-10/5 h-10/5 rounded-full flex items-center justify-center transition-all duration-100">
      <base-icon
        :name="setArrow"
        :class="{ 'transform rotate-180': isOpen }"
        class="group-hover:text-primary transition-transform duration-300"
        :title="isOpen ? 'Contraer submenú' : 'Desplegar submenú'" 
      />
    </div>
    <span 
      class="user-name-div truncate hidden md:block"
      aria-hidden="true">
      {{ user }}
    </span>
    <el-tooltip 
      v-model="tooltipVisible"
      :manual="true"
      :tabindex="-1"
      placement="top" 
      :open-delay="750"
      >
      <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
        @mouseenter="tooltipVisible = true"
        @mouseleave="tooltipVisible = false"
        >{{ user }}</div>
      <div 
        class="w-10/5 h-10/5 bg-primary-700 rounded-full overflow-hidden flex items-center justify-center"
        >
        <base-icon
          :name="role === 'SuperAdministrador' ? 'avatarsa' : 'avatar'"
          size="lg"
          class="group-hover:text-primary text-secondary dark:text-darkblue-200 dark:hover:bg-darkblue-600 hover:text-primary dark:hover:text-primary active:bg-primary-100 active:text-primary focus:bg-primary-100 focus:text-primary"
        />
      </div>
    </el-tooltip>
  </button>
</template>

<script>
import { bus } from '@/main'

export default {
  name: 'base-avatar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [String, Array],
      default: ''
    },
    onMobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      tooltipVisible: false,
    }
  },
  computed: {
    setArrow: function () {
      return this.onMobile ? 'chevronup' : 'chevrondown'
    },
    user: function () {
      const user = this.$store.getters['auth/user']
      if (user === null || user === undefined) return ''
      else return user.Usuario
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  watch: {
    tooltipVisible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydown)
        bus.$emit('asideTooltipVisibility', true)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
        bus.$emit('asideTooltipVisibility', false)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
    if (this.tooltipVisible) bus.$emit('asideTooltipVisibility', false)
  },
  methods: {
    toggleAvatar: function () {
      this.$emit('toggleAvatar')
    },
    onKeydown (event) {
      if (event.key === 'Escape' && this.tooltipVisible) {
        this.tooltipVisible = false
        // Avisamos para que el base-drop-down no se cierre con este mismo ESC.
        bus.$emit('tooltip-dismissed-by-esc')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-name-div{
  max-width: 200px;
}
</style>
